import { render, staticRenderFns } from "./Baccarat1.vue?vue&type=template&id=a7095b9e&scoped=true"
import script from "./Baccarat1.vue?vue&type=script&lang=js"
export * from "./Baccarat1.vue?vue&type=script&lang=js"
import style0 from "./Baccarat1.vue?vue&type=style&index=0&id=a7095b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7095b9e",
  null
  
)

export default component.exports